import React from 'react';
import Panel from './Panel';
import BrokerRegistration from '../../components/Panel/Brokers/BrokerRegistration';

const BrokerRegistrationPage = () => {

  return (
    <Panel>
      <div>
        <BrokerRegistration />
      </div>
    </Panel>

  );
};

export default BrokerRegistrationPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/BrokerRegistration.js
 **/